export default __webpack_public_path__ + "static/media/0a.7b6c4640.gif";